import React from "react";
import ReactDOM from "react-dom/client";
import "@/lib/preload";
import "@/index.css";
import "@/styles/design-system.css";
import App from "@/App";

// index.html sets __asLeaving while it redirects www -> apex: boot nothing (no data calls).
if (!window.__asLeaving) {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

  // P27 — Core Web Vitals RUM (non-blocking, no personal data). R6 — its code loads
  // after the page has loaded (metrics are buffered, so nothing is missed).
  const loadVitals = () => import("@/utils/webVitals").then((m) => m.initWebVitals());
  if (document.readyState === "complete") loadVitals();
  else window.addEventListener("load", loadVitals, { once: true });
}
